import utils from '@/utils';
import fetch from './fetch';

// 班级基础信息
const getMyClassInf = params => {
  const tmp = { ...params };
  if (tmp.class_status) {
    const [key, value] = tmp.class_status.split('-');
    tmp[key] = value;
    delete tmp.class_status;
  }
  return fetch({ url: '/my_class', params: tmp });
};

const getClassInf = params => {
  const tmp = { ...params };
  if (tmp.class_status) {
    const [key, value] = tmp.class_status.split('-');
    tmp[key] = value;
    delete tmp.class_status;
  }

  if (tmp.publish_status === '1') {
    tmp.audit_status = 2;
  }
  return fetch({ url: '/class_info', params: tmp });
};

const addClassInf = ({ params }) => fetch({ url: '/class_info', params, methold: 'post' });
const controlClass = ({ id, params, methold }) => fetch({ url: `/class_info/${id}`, params, methold });
const activateClass = ({ params }) => fetch({ url: '/class_info/activate_publish', params });
const classNotRock = ({ params }) => fetch({ url: '/class_info/set_not_rocking_number', params });
const classPrePush = ({ params }) => fetch({ url: '/class_info/pre_publish', params, methold: 'post' });
const classPush = ({ params }) => fetch({ url: '/class_info/publish', params, methold: 'post' });
const classRevoke = ({ params }) => fetch({ url: '/class_info/revoke', params, methold: 'post' });
const activateClassSignUp = ({ params }) => fetch({ url: '/class_info/activate_sign_up', params, methold: 'post' });
const activateClassSignClose = ({ params }) => fetch({ url: '/class_info/close_sign_up', params, methold: 'post' });
const passAudit = ({ params }) => fetch({ url: '/class_info/pass_audit', params, methold: 'post' });
const rejectAudit = ({ params }) => fetch({ url: '/class_info/reject_audit', params, methold: 'post' });
const spikeClass = ({ params }) => fetch({ url: '/class_info/close_rocking_interview ', params, methold: 'post' });
const closeRocking = ({ params }) => fetch({ url: '/batch_close_rocking ', params, methold: 'post' });

const auditStatus = () => fetch({ url: '/audit_status' });
const publishStatus = () => fetch({ url: '/publish_status' });
const signUpStatus = () => fetch({ url: '/sign_up_status' });
const classPhase = () => fetch({ url: '/class_phase' });
const refundType = () => fetch({ url: '/get_refund_type' });
const materialRefundType = () => fetch({ url: '/get_material_refund_type' });

const year = () => fetch({ url: '/year' });
const termChoose = () => fetch({ url: '/term_choose' });
const classMode = () => fetch({ url: '/class_mode_choose' });
const interviewStatus = () => fetch({ url: '/interview_status_choose' });
const classRocking = () => fetch({ url: '/class_rocking_number' });

const classRoomQuery = params => fetch({ url: '/class_info/class_room_query', params, methold: 'post' });
const feeLevelQuery = params => fetch({ url: '/class_info/fee_level_query', params });
const teacherQuery = params => fetch({ url: '/class_info/teacher_query', params, methold: 'post' });
const teachingAssistantQuery = params =>
  fetch({ url: '/class_info/teaching_assistant_query', params, methold: 'post' });

const classSubmit = ({ params }) => fetch({ url: '/class_info/submit', params, methold: 'post' });
const mergeClassQuery = ({ params }) => fetch({ url: '/merge_class_query', params });
const mergeClass = ({ params }) => fetch({ url: '/merge_class', params, methold: 'post' });
// 草稿
const classDrafts = ({ params, methold }) => fetch({ url: '/class_drafts', params, methold });
const controlClassDrafts = ({ id, params, methold }) => fetch({ url: `/class_drafts/${id}`, params, methold });

// 多媒体
const getClassMedia = ({ id }) => fetch({ url: `/class_info/${id}/class_cover` });
// 课表
const getClassSchedule = ({ id, methold, params }) => fetch({ url: `/class_info/${id}/class_detail`, methold, params });
const getAgeLimit = ({ params }) => fetch({ url: '/get_age_limit', params });
// 代课
const supplyTypeChoose = () => fetch({ url: '/supply_type_choose' });
const classQuery = params =>
  fetch({
    url: '/class_supply/class_query',
    params: {
      query: params.query,
      supply_start_time: params.supply_time[0],
      supply_end_time: params.supply_time[1]
    }
  });
const classQueryByOrg = params =>
  fetch({
    url: '/get_class_list',
    params
  });

const classSupplyTeacherQuery = params =>
  fetch({
    url: '/class_supply/teacher_query',
    params: {
      query: params.query,
      supply_start_time: params.supply_time[0],
      supply_end_time: params.supply_time[1]
    }
  });
const getClassSupply = params => fetch({ url: '/class_supply', params });
const classSupply = ({ methold, params }) => fetch({ url: '/class_supply', methold, params });
const controlClassSupply = ({ id, methold, params }) => fetch({ url: `/class_supply/${id}`, methold, params });
const classSupplyPassAudit = ({ params, type }) => {
  if (type === 'center') return fetch({ url: '/class_supply/sub_center_pass', params, methold: 'patch' });
  return fetch({ url: '/class_supply/minister_pass', params, methold: 'patch' });
};
const classSupplyRejectAudit = ({ params, type }) => {
  if (type === 'center') return fetch({ url: '/class_supply/sub_center_reject', params, methold: 'patch' });
  return fetch({ url: '/class_supply/minister_reject', params, methold: 'patch' });
};
const classSupplyRevokeSupply = ({ params }) => fetch({ url: '/class_supply/revoke_supply', params, methold: 'patch' });
const classSupplySubmit = ({ params }) => fetch({ url: '/class_supply/submit', params, methold: 'patch' });

const getSupplyClassCount = ({ params }) => fetch({ url: '/class_supply/get_supply_class_count', params });

const setRemuneration = ({ params }) => fetch({ url: '/set_remuneration', params, methold: 'post' });
const holidayList = ({ params }) => fetch({ url: '/query_holiday_list', params });

const classIdQuery = params =>
  fetch({
    url: '/global_config/class_query',
    params: { ...params, page_no: params.page_no || 1, page_size: params.page_size || 20 }
  });

// 子班 && 母班
const childClassList = params => fetch({ url: `/class_relation/${params.origin_class_id}`, params });
const allClassSelect = params => fetch({ url: '/class_relation/class_select', params });
const createRelation = ({ params }) =>
  fetch({ url: `/class_relation/${params.origin_class_id}`, params, methold: 'post' });
const relationUnbind = ({ params }) =>
  fetch({ url: `/class_relation/${params.origin_class_id}/unbind`, params, methold: 'post' });
const singUpList = params => fetch({ url: `/split_class/${params.origin_class_id}/sign_up_list`, params });
const createSignUpRelation = ({ origin_class_id, split_class_id, params }) =>
  fetch({
    url: `/split_class/${origin_class_id}/${split_class_id}`,
    params,
    methold: 'post'
  });
const splitClassList = ({ origin_class_id }) => fetch({ url: `/split_class/${origin_class_id}/class_select` });
const splitClassSignUpList = params => fetch({ url: `/split_class/${params.origin_class_id}`, params });
const splitClassRest = ({ origin_class_id, params }) =>
  fetch({ url: `/split_class/${origin_class_id}/reset`, params, methold: 'post' });
const splitClassRestAll = ({ origin_class_id }) =>
  fetch({ url: `/split_class/${origin_class_id}/reset_all`, methold: 'post' });
const splitClassRestConfirm = ({ origin_class_id }) =>
  fetch({ url: `/split_class/${origin_class_id}/confirm`, methold: 'post' });
const exportClassInfo = ({ params }) =>
  fetch({
    url: '/export_class_info',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportClassCoster = ({ params }) =>
  fetch({
    url: '/export_class_roster',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportMyClass = ({ params }) =>
  fetch({
    url: '/export_my_class',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });
const exportSignUp = ({ params }) =>
  fetch({
    url: '/export_sign_up',
    params,
    isFull: true,
    config: { responseType: 'blob' }
  });

const batchSetSignUpTime = ({ params }) =>
  fetch({
    url: '/batch_set_sign_up_time',
    methold: 'post',
    params
  });

const interviewReview = params => fetch({ url: '/interview_review_list', params });

const address = params => fetch({ url: '/get_mail_info_list', params });
const updateMailInfo = ({ id, params }) => fetch({ url: `/update_mail_info/${id}`, params, methold: 'put' });
const batchUpdateMail = ({ params }) => fetch({ url: '/batch_update_mail_status', params, methold: 'put' });
const exportMailInfo = ({ params }) =>
  fetch({ url: '/export_mail_info', params, isFull: true, config: { responseType: 'blob' } });

const getAccessControl = params => fetch({ url: '/get_access_control_info_list', params });

const exportAccessControl = ({ params }) =>
  fetch({ url: '/export_access_control_info', params, isFull: true, config: { responseType: 'blob' } });

// 集体报名发送短信
const sendTeamMessages = params => fetch({ url: `/one_key_not_pay_notify?${utils.objToUrl(params)}`, methold: 'post' });

const getSubstituteList = params => fetch({ url: '/substitute_apply_record', params });
const substituteApply = ({ params }) => fetch({ url: '/substitute_apply_record', params, methold: 'post' });
const getCourseQuery = ({ params }) => fetch({ url: '/substitute_conform_course_query', params });
const getReplaceCourseQuery = ({ params }) => fetch({ url: '/replace_conform_course_query', params });
const getReplaceList = params => fetch({ url: '/replace_apply_record', params });
const replaceApply = ({ params }) => fetch({ url: '/replace_apply_record', params, methold: 'post' });
const replaceDelete = ({ params, replace_apply_record_id }) => fetch({ url: `/replace_apply_record/${replace_apply_record_id}`, params, methold: 'delete' });
const substituteDelete = ({ params, substitute_apply_record_id }) => fetch({ url: `/substitute_apply_record/${substitute_apply_record_id}`, params, methold: 'delete' });
const replaceApplySubmit = ({ params }) => fetch({ url: '/replace_apply_submit', params, methold: 'patch' });
const replaceUpdate = ({ params, replace_apply_record_id }) => fetch({ url: `/replace_apply_record/${replace_apply_record_id}`, params, methold: 'put' });
const replaceFirstPass = ({ params }) => fetch({ url: '/replace_apply_first_pass', params, methold: 'patch' });
const replaceSecondPass = ({ params }) => fetch({ url: '/replace_apply_second_pass', params, methold: 'patch' });
const replaceReject = ({ params }) => fetch({ url: '/replace_apply_reject', params, methold: 'patch' });
const replaceRevoke = ({ replace_apply_record_id }) => fetch({ url: `/replace_apply_revoke/${replace_apply_record_id}`, methold: 'post' });
const substituteApplySubmit = ({ params }) => fetch({ url: '/substitute_apply_submit', params, methold: 'patch' });
const substituteFirstPass = ({ params }) => fetch({ url: '/substitute_apply_first_pass', params, methold: 'patch' });
const substituteSecondPass = ({ params }) => fetch({ url: '/substitute_apply_second_pass', params, methold: 'patch' });
const substituteReject = ({ params }) => fetch({ url: '/substitute_apply_reject', params, methold: 'patch' });
const substituteRevoke = ({ substitute_apply_record_id }) => fetch({ url: `/substitute_apply_revoke/${substitute_apply_record_id}`, methold: 'post' });
const getSubstituteRecord = ({ substitute_apply_record_id }) => fetch({ url: `/substitute_apply_record/${substitute_apply_record_id}`, methold: 'get' });
const substituteUpdate = ({ params, substitute_apply_record_id }) => fetch({ url: `/substitute_apply_record/${substitute_apply_record_id}`, params, methold: 'put' });
const checkInVerifyList = params => fetch({ url: '/get_teacher_repair_list', params });
const checkInVerifyPost = (id, params) => fetch({ url: `/teacher_repair_check/${id}`, params, methold: 'post' });
const checkInVerifyPut = params => fetch({ url: '/get_teacher_repair_list', params, methold: 'put' });
const checkInVerifyGet = id => fetch({ url: `/teacher_repair_check/${id}`, methold: 'get' });
const checkInVerifyDetails = ({ id }) => fetch({ url: `/get_teacher_repair_detail/${id}` });
const checkInVerifyStudentGet = ({ class_detail_id, ...params }) => fetch({ url: `/get_student_check/${class_detail_id}`, params });
const checkInVerifyStudentPost = ({ class_detail_id, ...params }) => fetch({ url: `/student_check/${class_detail_id}`, params, methold: 'post' });
const getRepairCourseQuery = ({ params }) => fetch({ url: '/get_teacher_repair_course', params });
const fenceList = params => fetch({ url: '/electronic_fence_list', params, methold: 'post' });
const fenceCreate = params => fetch({ url: '/electronic_fence', params, methold: 'post' });
const fencePut = (id, params) => fetch({ url: `/electronic_fence/${id}`, params, methold: 'put' });
const fenceRemove = id => fetch({ url: `/electronic_fence/${id}`, methold: 'delete' });
const fenceUpdateStatus = (id, params) => fetch({ url: `/electronic_fence_status/${id}`, params, methold: 'put' });
const fetchGetRegisterStudent = ({ class_id, ...params }) => fetch({ url: `/get_student_check_by_class_id/${class_id}`, params });
const fetchPostSuspendClass = params => fetch({ url: '/suspend_class', params, methold: 'post' });
const fetchGetSuspendClassTime = params => fetch({ url: '/get_suspend_class_time', params, methold: 'post' });

export default {
  closeRocking,
  spikeClass,
  exportAccessControl,
  getAccessControl,
  exportMailInfo,
  batchUpdateMail,
  updateMailInfo,
  address,
  teachingAssistantQuery,
  interviewReview,
  batchSetSignUpTime,
  getAgeLimit,
  exportSignUp,
  exportMyClass,
  exportClassInfo,
  exportClassCoster,
  childClassList,
  allClassSelect,
  createRelation,
  relationUnbind,
  singUpList,
  createSignUpRelation,
  splitClassList,
  splitClassSignUpList,
  splitClassRest,
  splitClassRestAll,
  splitClassRestConfirm,
  getClassInf,
  controlClass,
  activateClass,
  classNotRock,
  classPrePush,
  classPush,
  classRevoke,
  activateClassSignUp,
  activateClassSignClose,
  auditStatus,
  publishStatus,
  signUpStatus,
  classPhase,
  classRoomQuery,
  year,
  termChoose,
  classMode,
  feeLevelQuery,
  teacherQuery,
  addClassInf,
  getClassMedia,
  getClassSchedule,
  classRocking,
  interviewStatus,
  passAudit,
  rejectAudit,
  supplyTypeChoose,
  classQuery,
  classQueryByOrg,
  classSupplyTeacherQuery,
  classSupply,
  controlClassSupply,
  classSupplyPassAudit,
  classSupplyRejectAudit,
  classSupplyRevokeSupply,
  classSupplySubmit,
  getSupplyClassCount,
  getClassSupply,
  controlClassDrafts,
  classDrafts,
  refundType,
  materialRefundType,
  getMyClassInf,
  setRemuneration,
  holidayList,
  classIdQuery,
  classSubmit,
  mergeClassQuery,
  mergeClass,
  sendTeamMessages,
  getSubstituteList,
  substituteApply,
  getCourseQuery,
  getReplaceList,
  replaceApply,
  replaceDelete,
  substituteDelete,
  replaceApplySubmit,
  replaceFirstPass,
  replaceSecondPass,
  replaceReject,
  replaceRevoke,
  substituteApplySubmit,
  substituteFirstPass,
  substituteSecondPass,
  substituteReject,
  substituteRevoke,
  getSubstituteRecord,
  substituteUpdate,
  replaceUpdate,
  getReplaceCourseQuery,
  checkInVerifyList,
  checkInVerifyPut,
  checkInVerifyPost,
  checkInVerifyGet,
  checkInVerifyStudentGet,
  checkInVerifyStudentPost,
  checkInVerifyDetails,
  getRepairCourseQuery,
  fenceCreate,
  fencePut,
  fenceRemove,
  fenceList,
  fenceUpdateStatus,
  fetchGetRegisterStudent,
  fetchPostSuspendClass,
  fetchGetSuspendClassTime
};
